const transitionDurationMs = {
  enter: 250,
  exit: 100
};
const backdrop = "c2lb7n6fvf";
const content = "c2lcqypz2u";
const wrapper = "c2lw9bow10";
const heading = "c2lh754rqe";
const body = "c2lbtzvm8r";
const actionsList = "c2la1khcydk";

export { actionsList, backdrop, body, content, heading, transitionDurationMs, wrapper };
import "./integration.notifier.style.linaria.module.css";
//# sourceMappingURL=integration.notifier.style.js.map
